import { render } from "./OtherDepartment.vue?vue&type=template&id=ddcb673a&scoped=true&ts=true"
import script from "./OtherDepartment.vue?vue&type=script&lang=ts"
export * from "./OtherDepartment.vue?vue&type=script&lang=ts"

import "./OtherDepartment.vue?vue&type=style&index=0&id=ddcb673a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddcb673a"]])

export default __exports__